import React, { AnchorHTMLAttributes } from 'react';
import s from '../TemplateCard.module.scss';
import { TemplateGalleryCard } from '../../../../types/index';
import { TFunction } from '@wix/fe-essentials-business-manager/dist/types/exports/i18n';

export interface TemplateCardLinkWrapperProps {
  t: TFunction;
  templateHref: string | undefined;
  onClick: () => void;
  template: TemplateGalleryCard;
  children: React.ReactNode;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
  setFocused: React.Dispatch<React.SetStateAction<boolean>>;
  anchorProps?: AnchorHTMLAttributes<HTMLAnchorElement>;
}

const TemplateCardLinkWrapper = ({
  template,
  children,
  templateHref,
  anchorProps = {},
  onClick,
  setHover,
  setFocused,
  t,
}: TemplateCardLinkWrapperProps) => {
  return (
    <div
      aria-labelledby={`template-title-${template.title}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false);
        template.media?.animatedPreview && setFocused(false);
      }}
    >
      {templateHref ? (
        <a
          data-hook={`template-card-container-${template.id}`}
          href={templateHref}
          aria-label={t('marketplace.templates-page.view-template-cta')}
          onClick={onClick}
          rel="noreferrer"
          {...anchorProps}
          className={
            anchorProps?.className
              ? `${s.cardContainer} ${anchorProps.className}`
              : s.cardContainer
          }
        >
          {children}
        </a>
      ) : (
        <div
          className={
            anchorProps?.className
              ? `${s.cardContainer} ${anchorProps.className}`
              : s.cardContainer
          }
          data-hook={`template-card-container-${template.id}`}
          aria-disabled="true"
          style={{ cursor: 'default' }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default TemplateCardLinkWrapper;
